'use strict';

module.exports = {
  Carousel: require('./components/Carousel'),
  Thumbs: require('./components/Thumbs')
};